<template>
  <div class="travelsolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0" >
                  <li v-for="(item,index) in difficultList" :key="index">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                    <div class="programItem">
                      <div class="programItemName">旅行社入驻</div>
                      <ul v-if="flowList.length>0" class="listTop">
                          <li v-for="(item,index) in flowList" :key="index">
                            <dl>
                              <dt><img :src="item.img"></dt>
                              <dd>{{item.name}}</dd>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                      </ul> 
                      <p>全程司法通道服务：合同审查、律师咨询、鉴定公证、解纷解决。</p>
                    </div>
                     <div class="programItem programItemb">
                       <div class="programItemName">用户购买旅游服务</div>
                        <ul v-if="flowListx.length>0" class="listBottom">
                          <li v-for="(item,index) in flowListx" :key="index">
                            <dl>
                              <dt><span v-html="item.name"></span></dt>
                              <dd>{{item.content}}</dd>
                            </dl>
                          </li>
                        </ul> 
                     </div>
                  </div>
                  <div class="programBoxCon">
                      <p>
                                对于旅游行业，通过实名认证，确认企业及其用户的身份，并通过电子签约平台签署《旅游服务合同》等一些列的电子文件，利用技术手段固化并存证整个证据链。同时，利用区块链技术通过司法联盟链，将数据同步至多家公证处、司法鉴定机构、仲裁机构以及互联网法院，保证电子数据可以作为证据被仲裁所采信。并将相应的履约条款作为触发条件写入智能合约，满足触发条件后，自动执行。
                      </p>
                      <p>
                                《旅游法》的第五章，用了整个章节阐述了“旅游服务合同”，在第五十七条，明确要求“旅行社组织和安排旅游活动，应当与旅游者订立合同”。智签电子签约平台旅游行业解决方案可以为旅游平台提供实名认证、电子合同签署、电子数据存证、在线公证、在线鉴定、律师咨询等多元化的在线服务，保障平台与用户的合法权益。
                      </p>
                  </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="(item,index) in guaranteeList" :key="index">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span v-html="item.title"></span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/cbxld_icon.png"),
          title:"签署难成本高",
          content:"在线旅游行业近些年发展迅速，多为跨地区客户，纸质合同签署流程繁琐，耗时长，效率低，签署成本高。"
        },
        {
          img:require("../../../assets/images/solution/safe_icon.png"),
          title:"安全性差",
          content:"因其自身的特点，纸质文件存在易丢失、易损毁的特点，一旦文件被损毁或者丢失，将会造成严重的后果。"
        },
        {
          img:require("../../../assets/images/solution/jyhgyq_icon.png"),
          title:"行业合规要求",
          content:"《旅游法》明确要求“旅行社组织和安排旅游活动，应当与旅游者订立合同”，部分平台采用点击确认的方式，存在较大的法律风险。"
        },
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/signcontrol_img.png"),
          icon:require('../../../assets/images/solution/signcontrol_pre_icon.png.png'),
          title:"签控一体",
          content:"签约、履约等全证据链全部通过司法联盟链进行存证，通过智能合约进行履约管控，控制违约风险，保障签约方的合法权益。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution/judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
      ],
      flowList:[
        {
          img:require("../../../assets/images/solution/hzqt_icon.png"),
          name:"合作洽谈",
          content:'洽谈并确认合作'
        },
        {
          img:require("../../../assets/images/solution/smrz_icon.png"),
          name:"注册实名",
          content:'确认服务协议，并进行申请人认证与企业认证'
        },
        {
          img:require("../../../assets/images/solution/scclbsk_icon.png"),
          name:"上传材料并审核",
          content:'上传旅行社资料，申请人资料及其他资质'
        },
        {
          img:require("../../../assets/images/solution/lxsqs_icon.png"),
          name:"旅行社签署",
          content:'申请人在线发起《旅行社入驻合同》并进行签署'
        },
        {
          img:require('../../../assets/images/solution/ptqs_icon.png'),
          name:"平台签署",
          content:'在线旅游平台调用签署接口，自动完成合同签署'
        },
        {
          img:require('../../../assets/images/solution/sjcz_icon.png'),
          name:"数据存证",
          content:'全证据链电子数据存证上链，同步至司法联盟链'
        },
        {
          img:require('../../../assets/images/solution/sxfb_icon.png'),
          name:"上线发布",
          content:'旅行社将自己的旅游产品进行上传、审核通过后发布'
        },
      ],
      flowListx:[
       {
         name:"注册<br/>实名",
         content:'注册账号，同意服务协议，填写相关资料进行实名认证'
       },
       {
         name:"选定<br/>方案",
         content:'用户确定出行方案'
       },
       {
         name:"用户<br/>签署",
         content:'客户在线发起合同签署签订《旅游服务合同》'
       },
       {
         name:"平台<br/>签署",
         content:'在线旅游平台调用签署接口，自动完成合同签署'
       },
       {
         name:"数据<br/>存证",
         content:'全证据链电子数据存证上链，同步至司法联盟链'
       },
       {
         name:"创建<br/>履约",
         content:'通过服务协议、合同内容，生成履约条款，写入智能合约'
       },
      {
         name:"自动<br/>执行",
         content:'根据智能合约写入的触发条件，满足时自动执行相应的计算机协议'
       },
       {
         name:'纠纷<br/>处理',
         content:'对于违约或者执行失败的合约，提供司法通道服务，进行在线纠纷解决'
       }
    ]
    }
  }
}
</script>
<style lang="scss" >
.travelsolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
      padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 40px) / 3);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            .programItem{
              width:100%;
              overflow: hidden;
              background: #FAFAFA;
              border: 1px dashed rgb(180,180,180);
               box-sizing: border-box;
               margin-bottom:30px;
              .programItemName{
                height: 40px;
                line-height: 40px;
                font-size: 18px;
                text-align: center;
                color: #646464;
                background: #F0F0F0;
                border-bottom: 1px dashed rgb(180,180,180);
                box-sizing: border-box;
              }
              p{
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                text-align: center;
                color: #646464;
                background: #FAFAFA;
                border-top: 1px dashed rgb(180,180,180);
              }
              ul{
                width:100%;
                display: block;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding:40px 20px 20px 20px;
                box-sizing: border-box;
                li{ 
                  text-align:center;
                  position: relative;
                  dl{
                  width: 130px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  flex-direction: column;
                    dt{
                      width:60px;
                      height: 60px;
                      display: flex;
                      justify-content:center;
                      border-radius: 50%;
                      align-items: center;
                      text-align: justify;
                      background: #B41C2E;
                      border-radius: 12px;
                      margin-bottom: 10px;
                      font-size: 16px;
                      color: #FFFFFF;
                      letter-spacing: 2px;
                      img{
                        width: 30px;
                        height: auto;
                      }
                    }
                    dd:nth-child(2){
                      font-size: 18px;
                      color: #787878;
                      margin-bottom: 10px;
                    }
                    dd:nth-child(3){
                      font-size: 14px;
                        color: #969696;
                        line-height: 22px;
                        text-align: justify;
                    }
                  }
                }
                li:after{
                    content: '';
                    display: block;
                    position: absolute;
                    right: -58px;
                    top: 27px;
                    width: 76px;
                    height: 9px;
                    background:url("../../../assets/images/solution/shrz_line_img.png")no-repeat;
                    background-size:100% 100%;
                }
                li:last-child:after{
                  background:none;
                }
              }
              .listBottom{
                margin-top: 74px;
                  margin-bottom: 60px;
                li{
                  position: relative;
                }
                li:after{
                  content: '';
                    display: block;
                    position: absolute;
                    left: 101px;
                    top: 25px;
                    width: 76px;
                    height: 10px;
                    background:url("../../../assets/images/solution/shrz_line_img.png")no-repeat;
                    background-size:100% 100%;
                }
              
              }
            }
            .programItemb{
              .listBottom{
              margin:0;
                li{
                  dl{
                    width:100px;
                    dd{
                      font-size: 14px!important;
                    color: #969696!important;
                    line-height: 22px;
                    text-align: justify;
                    margin:0 !important;
                    }
                  }
                }
                li:after{
                  left:86px;
                }
                 li:nth-child(7):after{
                   background: none;
                 }
                 li:nth-child(6):before{
                       content: '';
                        display: block;
                        position: absolute;
                        left: 51px;
                        top: -18px;
                        width: 309px;
                       height: 20px;
                      background:url("../../../assets/images/solution/wan.png")no-repeat;
                 }
              }
            }
          }
          .programBoxCon{
            h1{
              width:100%;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 18px;
              font-weight: normal;
              color: #787878;
              background: #EBEBEB;
              margin-bottom: 16px;
            }
            p{
              font-size: 14px;
              color:#787878;
              line-height: 26px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/signcontrol_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
